var map = {
	"./BFCENTER.png": 159,
	"./about1.jpg": 260,
	"./about2.jpg": 261,
	"./about3.jpg": 262,
	"./about4.jpg": 263,
	"./about5.jpg": 264,
	"./bags.jpg": 265,
	"./buy-heart.svg": 248,
	"./free-sell.svg": 249,
	"./logo-big.png": 266,
	"./logo-nav.png": 267,
	"./logo-web.png": 157,
	"./logo.png": 268,
	"./makeup.png": 250,
	"./nenes.png": 251,
	"./not-available.jpg": 156,
	"./offer.png": 252,
	"./pina.jpg": 253,
	"./shipping.svg": 254,
	"./slider.jpg": 242,
	"./slider3.jpg": 243,
	"./slider4.jpg": 244,
	"./ws.png": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;